import { styled } from "@mui/material/styles";

export const Wrapper = styled("header")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",

  "@media screen and (max-width: 435px)": {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginTop: "0.75rem",
  },
}));

export const Title = styled("span")(() => ({
  font: "700 18px/18px Manrope",
  color: "#465869",
  marginRight: "0.9375rem",
}));

export const List = styled("ul")(() => ({
  listStyle: "none",
  padding: 0,

  display: "flex",
  alignItems: "center",
  gap: "1rem",

  "@media screen and (max-width: 435px)": {
    flexDirection: "column",
    alignItems: "flex-start",
    marginTop: "0.5rem",
    gap: "0.25rem",
  },
}));

export const ListItem = styled("li")(() => ({
  font: "500 16px/20px Manrope",
  color: "#9ca6af",

  display: "flex",
  alignItems: "center",
  gap: "1rem",
  margin: 0,
  "& > span.value": {
    color: "#465869",
  },

  "@media screen and (max-width: 435px)": {
    gap: "0.25rem",
  },
}));
